import { useLocation } from 'react-router-dom';

import { useItineraryContext } from '@/context/ItineraryContext';
import { pages } from '@/hooks/useItineraryNavigation';
import { StyledFlexColumn } from '@/layout/FlexLayout';

import { StyledButton, Circle } from './styles';

import type { NavigationPageKey } from '@/hooks/useItineraryNavigation';
import type { ReactNode } from 'react';

interface ItineraryCheckoutStepButtonProps {
  to: NavigationPageKey;
  children: ReactNode;
  icon: ReactNode;
}

export function ItineraryCheckoutStepButton({ to, children, icon }: ItineraryCheckoutStepButtonProps) {
  const location = useLocation();
  const isActive = location.pathname.includes(pages[to].path);
  const { navigation } = useItineraryContext();

  return (
    <StyledButton type="button" onClick={() => navigation.to(to)} disabled={isActive}>
      <StyledFlexColumn alignItems="center">
        <Circle $active={isActive}>{icon}</Circle>
        {children}
      </StyledFlexColumn>
    </StyledButton>
  );
}
